/* Copyright (c) 2020-present CloudIO Inc */

import { SimpleNoDataFound } from 'api/NoDataFound';
import React from 'react';

export default function NoDataFound({
  message = 'No data found!',
}: {
  message?: React.ReactNode;
}) {
  return <SimpleNoDataFound msg={message} />;
}
